import React from 'react';
import { ModalContent, ModalHeader, Typography } from 'common/components';

export const Guarantee = () => (
  <>
    <ModalHeader title="Гарантия качества" />
    <ModalContent variant="simple">
      <Typography adaptive={false} variant="m" size="body_long">
        Мы&nbsp;в&nbsp;ответе за&nbsp;результат, поэтому предоставляем долгосрочные гарантии&nbsp;&mdash; 1&nbsp;год
        на&nbsp;все виды работ и&nbsp;от&nbsp;1&nbsp;года на&nbsp;сопутствующие товары.
      </Typography>
      
      <Typography adaptive={false} variant="m" size="body_long">
        При этом мы&nbsp;строго соблюдаем стандарты качества и&nbsp;держим под контролем каждый
        этап проекта&nbsp;&mdash; от&nbsp;замера до&nbsp;установки.
      </Typography>
    </ModalContent>
  </>
);
